import angular from 'angular';
import FundingDetailsService from './fundingDetailsService';

export default angular
  .module('scenes.loanAppSections.scenes.fundingDetailsSection.services', [])
  .service('fundingDetailsService', FundingDetailsService).name;
